import type { NumberedStepsBlockProps } from "@/puck/types";

function StepMarker({
  index,
  listStyle,
}: Readonly<{ index: number; listStyle: "numbered" | "bullets" }>) {
  if (listStyle === "bullets") {
    return (
      <span
        aria-hidden
        className="mt-2.5 h-2 w-2 shrink-0 rounded-full bg-gail-primary"
      />
    );
  }

  return (
    <span
      aria-hidden
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gail-primary font-monument text-sm font-semibold text-white"
    >
      {index + 1}
    </span>
  );
}

export function NumberedStepsBlock({
  listStyle = "numbered",
  items,
}: Readonly<NumberedStepsBlockProps>) {
  const ListTag = listStyle === "bullets" ? "ul" : "ol";

  if (items.length === 0) {
    return <ListTag className="max-w-xl space-y-4" />;
  }

  return (
    <ListTag className="max-w-xl space-y-4">
      {items.map((item, index) => (
        <li key={`step-${index}`} className="flex items-start gap-4">
          <StepMarker index={index} listStyle={listStyle} />
          <span className="pt-1 font-monument text-base leading-relaxed text-black/75 md:text-lg">
            {item.text}
          </span>
        </li>
      ))}
    </ListTag>
  );
}
